import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const ErrorRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/pages/error',
            element: <MaintenanceError />
        },
        // Route bắt hết, PHẢI đứng cuối mảng route của app.
        //
        // Trước đây không có nó: gõ sai đường dẫn, hoặc tài khoản BQL mở một trang chỉ khai
        // trong bộ route của hạnh sinh, thì useRoutes không khớp gì cả và trả về null —
        // người dùng nhìn thấy TRANG TRẮNG, không một dòng chữ nào giải thích.
        {
            path: '*',
            element: <MaintenanceError />
        }
    ]
};

export default ErrorRoutes;
